var _linearGradient, _g, _filter, _linearGradient2, _g2, _filter2, _linearGradient3, _filter3, _linearGradient4, _g3, _filter4, _linearGradient5, _filter5, _linearGradient6, _filter6, _filter7, _filter8, _linearGradient7, _filter9, _linearGradient8, _filter10, _linearGradient9, _filter11, _g4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRoyal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    id: "master_svg0_1292_4698"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "12.479790300130844%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "master_svg1_1371_08317/1311_4803",
    style: {
      maskType: "alpha"
    },
    maskUnits: "objectBoundingBox"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.668848046875,2.60733184375C8.668848046875,2.8745948437499997,8.531268046875,3.10972484375,8.323078046875,3.24577484375L10.865898046875,7.72838484375C10.997098046875,7.95967484375,11.286398046875,8.04780484375,11.524298046875,7.92896484375L14.312598046875,6.53592484375C14.250798046875,6.42581484375,14.215598046875,6.29881484375,14.215598046875,6.16358484375C14.215598046875,5.74268484375,14.556798046875,5.40146484375,14.977698046875,5.40146484375C15.398598046875,5.40146484375,15.739798046875,5.74268484375,15.739798046875,6.16358484375C15.739798046875,6.58449484375,15.398598046875,6.92570484375,14.977698046875,6.92570484375C14.922698046875,6.92570484375,14.869098046875,6.91987484375,14.817398046875,6.90881484375L12.543098046875,13.50321484375C12.542098046875,13.50611484375,12.541098046875,13.50901484375,12.539998046875,13.51191484375L13.252498046875,13.51191484375C13.430098046875,13.51191484375,13.573998046875,13.65581484375,13.573998046875,13.83341484375C13.573998046875,14.01091484375,13.430098046875,14.15491484375,13.252498046875,14.15491484375L2.415338046875,14.15491484375C2.237778046875,14.15491484375,2.093828046875,14.01091484375,2.093828046875,13.83341484375C2.093828046875,13.65581484375,2.237778046875,13.51191484375,2.415338046875,13.51191484375L3.289108046875,13.51191484375C3.288168046875,13.50931484375,3.287238046875,13.50671484375,3.286328046875,13.50411484375L0.966135046875,6.81778484375C0.956782046875,6.81817484375,0.947381046875,6.81836484375,0.937935046875,6.81836484375C0.563797046875,6.81836484375,0.260498046875,6.51506484375,0.260498046875,6.14092484375C0.260498046875,5.7667948437500005,0.563797046875,5.46349484375,0.937935046875,5.46349484375C1.312068046875,5.46349484375,1.615368046875,5.7667948437500005,1.615368046875,6.14092484375C1.615368046875,6.28628484375,1.569598046875,6.42094484375,1.491668046875,6.53127484375L4.289278046875,7.92896484375C4.527158046875,8.04780484375,4.816438046875,7.95967484375,4.947638046875,7.72838484375L7.490438046875,3.2458048437500002C7.282208046875,3.10976484375,7.144608046875,2.87461484375,7.144608046875,2.60733184375C7.144608046875,2.18642584375,7.485828046875,1.84521484375,7.906728046875,1.84521484375C8.327638046875,1.84521484375,8.668848046875,2.18642584375,8.668848046875,2.60733184375Z",
    fillRule: "evenodd",
    fill: "url(#master_svg0_1292_4698)",
    fillOpacity: 1
  })))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg2_1371_08317/1311_4813",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -1.6170230336205365,
    y: -0.37037038803100586,
    width: 4.234046067241073,
    height: 1.7407407760620117
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6666667461395264,
    result: "effect1_foregroundBlur"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.4357987344264984,
    y1: 0.00032212998485192657,
    x2: 0.43916751497169876,
    y2: 1.0002049553076515,
    id: "master_svg3_1292_4734"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "63.96755576133728%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "93.56830716133118%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "master_svg4_1371_08317/1311_4813",
    style: {
      maskType: "alpha"
    },
    maskUnits: "objectBoundingBox"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,28.5976619720459,0)",
    filter: "url(#master_svg2_1371_08317/1311_4813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.29883098602295,-0.4881591796875L15.246197986022949,17.5118408203125L16.91286098602295,17.5118408203125L18.421630986022947,-0.4881591796875L14.29883098602295,-0.4881591796875Z",
    fill: "url(#master_svg3_1292_4734)",
    fillOpacity: 1
  })))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg5_1371_08317/1311_4812",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -1.6170230336205365,
    y: -0.37037038803100586,
    width: 4.234046067241073,
    height: 1.7407407760620117
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6666667461395264,
    result: "effect1_foregroundBlur"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    id: "master_svg6_1292_4769"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.78125%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svg7_1371_08317/1311_4817",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -1.6170230336205365,
    y: -0.37037038803100586,
    width: 4.234046067241073,
    height: 1.7407407760620117
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6666667461395264,
    result: "effect1_foregroundBlur"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.4357987344264984,
    y1: 0.00032212998485192657,
    x2: 0.43916751497169876,
    y2: 1.0002049553076515,
    id: "master_svg8_1292_4734"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "63.96755576133728%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "93.56830716133118%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "master_svg9_1371_08317/1311_4817",
    style: {
      maskType: "alpha"
    },
    maskUnits: "objectBoundingBox"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,28.60346031188965,0)",
    filter: "url(#master_svg7_1371_08317/1311_4817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.301730155944824,-0.4881591796875L15.249097155944824,17.5118408203125L16.915760155944824,17.5118408203125L18.424530155944822,-0.4881591796875L14.301730155944824,-0.4881591796875Z",
    fill: "url(#master_svg8_1292_4734)",
    fillOpacity: 1
  })))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svga_1371_08317/1311_4816",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -1.6170230336205365,
    y: -0.37037038803100586,
    width: 4.234046067241073,
    height: 1.7407407760620117
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6666667461395264,
    result: "effect1_foregroundBlur"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1,
    y1: 0.5,
    x2: 0,
    y2: 0.5,
    id: "master_svgb_1292_4769"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.78125%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svgc_1371_08317/1311_4818",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.26666666666666666,
    y: -5.999999821186071,
    width: 1.5333333333333334,
    height: 12.999999642372142
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svgd_1292_4710"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "2.857142873108387%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.1599999964237213
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.21875%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.17000000178813934
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svge_1371_08317/1311_4807",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -2.0173365816156914,
    y: -0.5554406350919581,
    width: 5.034673163231383,
    height: 2.110881270183916
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6666667461395264,
    result: "effect1_foregroundBlur"
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svgf_1371_08317/1311_4805",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -2.0173365816156914,
    y: -0.5554406350919581,
    width: 5.034673163231383,
    height: 2.110881270183916
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.6666667461395264,
    result: "effect1_foregroundBlur"
  }))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svgg_1371_08317/1311_4820",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.26666666666666666,
    y: -11.999999642372142,
    width: 1.5333333333333334,
    height: 24.999999284744284
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "master_svgh_1292_4710"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "2.857142873108387%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.1599999964237213
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.21875%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.17000000178813934
  }))), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svgi_1371_08317/1311_4806",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.6570511566370303,
    y: -0.21920592588876128,
    width: 2.3141023132740606,
    height: 1.4384118517775226
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.38333332538604736,
    result: "effect1_foregroundBlur"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 1,
    y1: 0.9666157960891724,
    x2: 0.8269310609275506,
    y2: -0.5069820431179729,
    id: "master_svgj_1292_4725"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0.07962118834257126%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0
  }))), _filter10 || (_filter10 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svgk_1371_08317/1311_4819",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.26666666666666666,
    y: -11.999999642372142,
    width: 1.5333333333333334,
    height: 24.999999284744284
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: -1.388671875,
    x2: 0.5,
    y2: 2.5921630859375,
    id: "master_svgl_1292_4774"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "2.857142873108387%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.1599999964237213
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "49.21875%",
    stopColor: "#FFFFFF",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFFFFF",
    stopOpacity: 0.17000000178813934
  }))), _filter11 || (_filter11 = /*#__PURE__*/React.createElement("filter", {
    id: "master_svgm_1371_08317/1311_4814",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.4040491502578155,
    y: -0.1579714518376804,
    width: 1.808098300515631,
    height: 1.3159429036753607
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.3333333432674408,
    result: "effect1_foregroundBlur"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.668848046875,2.60733184375C8.668848046875,2.8745948437499997,8.531268046875,3.10972484375,8.323078046875,3.24577484375L10.865898046875,7.72838484375C10.997098046875,7.95967484375,11.286398046875,8.04780484375,11.524298046875,7.92896484375L14.312598046875,6.53592484375C14.250798046875,6.42581484375,14.215598046875,6.29881484375,14.215598046875,6.16358484375C14.215598046875,5.74268484375,14.556798046875,5.40146484375,14.977698046875,5.40146484375C15.398598046875,5.40146484375,15.739798046875,5.74268484375,15.739798046875,6.16358484375C15.739798046875,6.58449484375,15.398598046875,6.92570484375,14.977698046875,6.92570484375C14.922698046875,6.92570484375,14.869098046875,6.91987484375,14.817398046875,6.90881484375L12.543098046875,13.50321484375C12.542098046875,13.50611484375,12.541098046875,13.50901484375,12.539998046875,13.51191484375L13.236598046875,13.51191484375C13.414198046875,13.51191484375,13.558098046875,13.65581484375,13.558098046875,13.83341484375C13.558098046875,14.01091484375,13.414198046875,14.15491484375,13.236598046875,14.15491484375L2.399388046875,14.15491484375C2.2218180468749997,14.15491484375,2.077878046875,14.01091484375,2.077878046875,13.83341484375C2.077878046875,13.65581484375,2.2218180468749997,13.51191484375,2.399388046875,13.51191484375L3.289108046875,13.51191484375C3.288168046875,13.50931484375,3.287238046875,13.50671484375,3.286328046875,13.50411484375L0.966135046875,6.81778484375C0.956782046875,6.81817484375,0.947381046875,6.81836484375,0.937935046875,6.81836484375C0.563797046875,6.81836484375,0.260498046875,6.51506484375,0.260498046875,6.14092484375C0.260498046875,5.7667948437500005,0.563797046875,5.46349484375,0.937935046875,5.46349484375C1.312068046875,5.46349484375,1.615368046875,5.7667948437500005,1.615368046875,6.14092484375C1.615368046875,6.28628484375,1.569598046875,6.42094484375,1.491668046875,6.53127484375L4.289278046875,7.92896484375C4.527158046875,8.04780484375,4.816438046875,7.95967484375,4.947638046875,7.72838484375L7.490438046875,3.2458048437500002C7.282208046875,3.10976484375,7.144608046875,2.87461484375,7.144608046875,2.60733184375C7.144608046875,2.18642584375,7.485828046875,1.84521484375,7.906728046875,1.84521484375C8.327638046875,1.84521484375,8.668848046875,2.18642584375,8.668848046875,2.60733184375Z",
    fillRule: "evenodd",
    fill: "#EEEEEE",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#master_svg1_1371_08317/1311_4803)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,20.3535213470459,0)",
    mask: "url(#master_svg4_1371_08317/1311_4813)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,29.5205135345459,0)",
    filter: "url(#master_svg5_1371_08317/1311_4812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.76025676727295,-0.4881591796875L15.707623767272949,17.5118408203125L17.37428676727295,17.5118408203125L18.883056767272947,-0.4881591796875L14.76025676727295,-0.4881591796875Z",
    fill: "url(#master_svg6_1292_4769)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,20.35638999938965,0)",
    mask: "url(#master_svg9_1371_08317/1311_4817)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,29.52631187438965,0)",
    filter: "url(#master_svga_1371_08317/1311_4816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.763155937194824,-0.4881591796875L15.710522937194824,17.5118408203125L17.377185937194824,17.5118408203125L18.885955937194822,-0.4881591796875L14.763155937194824,-0.4881591796875Z",
    fill: "url(#master_svgb_1292_4769)",
    fillOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,10.55489444732666,-6.19722843170166)",
    filter: "url(#master_svgc_1371_08317/1311_4818)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.37606143951416,2.1788330078125L23.37606143951416,2.1788330078125L23.37606143951416,2.8455000078125L8.37606143951416,2.8455000078125L8.37606143951416,2.1788330078125Z",
    fillRule: "evenodd",
    fill: "url(#master_svgd_1292_4710)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.9614390730857849,0.2750181555747986,-0.2750181555747986,0.9614390730857849,1.5102327505879316,-3.747354946084613)",
    filter: "url(#master_svge_1371_08317/1311_4807)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.11824893951416,
    y: 3.5118408203125,
    width: 3.3046875,
    height: 12.002483367919922,
    rx: 0,
    fill: "#B2B2B2",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.9614390730857849,0.2750181555747986,0.2750181555747986,0.9614390730857849,3.16122196766122,-0.443242779132504)",
    filter: "url(#master_svgf_1371_08317/1311_4805)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.10408878326416,
    y: 3.5118408203125,
    width: 3.3046875,
    height: 12.002483367919922,
    rx: 0,
    fill: "#707070",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,8.10567569732666,-8.41500186920166)",
    filter: "url(#master_svgg_1371_08317/1311_4820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.26033878326416,-0.1546630859375L23.26033878326416,-0.1546630859375L23.26033878326416,0.1786699140625L8.26033878326416,0.1786699140625L8.26033878326416,-0.1546630859375Z",
    fillRule: "evenodd",
    fill: "url(#master_svgh_1292_4710)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,29.52067756652832,0)",
    filter: "url(#master_svgi_1371_08317/1311_4806)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.93589878326416,13.8930269140625L14.602238783264161,6.8980824140625L14.91843878326416,6.7925914140625L17.25209878326416,13.7875369140625L16.93589878326416,13.8930269140625Z",
    fillRule: "evenodd",
    fill: "url(#master_svgj_1292_4725)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0,1,-1,0,9.43917179107666,-7.08150577545166)",
    filter: "url(#master_svgk_1371_08317/1311_4819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.26033878326416,1.1788330078125L23.26033878326416,1.1788330078125L23.26033878326416,1.5121660078125L8.26033878326416,1.5121660078125L8.26033878326416,1.1788330078125Z",
    fillRule: "evenodd",
    fill: "url(#master_svgl_1292_4774)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,1,31.45134162902832,0)",
    filter: "url(#master_svgm_1371_08317/1311_4814)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.94459681451416,5.8738221828125Q15.947317814514161,5.8574948828125,15.947317814514161,5.8409423828125Q15.947317814514161,5.8011598828125,15.93209381451416,5.7644056828125Q15.91686981451416,5.7276513828125,15.88873981451416,5.6995213828125Q15.86060881451416,5.6713903828125,15.82385461451416,5.6561663828125Q15.78710041451416,5.6409423828125,15.74731791451416,5.6409423828125Q15.71181061451416,5.6409423828125,15.67847321451416,5.6531643828125Q15.64513581451416,5.6653873828125,15.61804281451416,5.6883383828125Q15.59094981451416,5.7112893828125,15.57341381451416,5.7421638828125Q15.55587681451416,5.7730383828125,15.55003881451416,5.8080625828125Q15.45173281451416,6.3979023828125,15.73041707451416,6.7359003828125Q15.97539281451416,7.0330123828125,16.48528981451416,7.0986123828125L18.59318081451416,12.9097223828125Q18.64640081451416,13.056442382812499,18.55681081451416,13.1842323828125Q18.46723081451416,13.3120223828125,18.31116081451416,13.3120223828125L16.02982781451416,13.3120223828125L16.23343181451416,14.4812823828125L18.55738081451416,14.4812823828125Q18.59716081451416,14.4812823828125,18.63391081451416,14.4660623828125Q18.67067081451416,14.4508323828125,18.69880081451416,14.4227023828125Q18.72693081451416,14.3945723828125,18.74215081451416,14.3578223828125Q18.75738081451416,14.3210723828125,18.75738081451416,14.2812823828125Q18.75738081451416,14.2415023828125,18.74215081451416,14.2047523828125Q18.72693081451416,14.1679923828125,18.69880081451416,14.1398623828125Q18.67067081451416,14.1117323828125,18.63391081451416,14.0965123828125Q18.59716081451416,14.0812823828125,18.55738081451416,14.0812823828125L16.56979881451416,14.0812823828125L16.50549881451416,13.7120223828125L18.31116081451416,13.7120223828125Q18.67532081451416,13.7120223828125,18.88435081451416,13.4138423828125Q19.09338081451416,13.115652382812499,18.96921081451416,12.7733323828125L16.77385081451416,6.7210863828125L16.64377281451416,6.7122993828125Q16.20494981451416,6.6826573828125,16.03903981451416,6.4814363828125Q15.87623681451416,6.2839823828125,15.94459681451416,5.8738221828125Z",
    fillRule: "evenodd",
    fill: "#FFFFFF",
    fillOpacity: 1
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoyal);
export default __webpack_public_path__ + "static/media/royal.d2b326de.svg";
export { ForwardRef as ReactComponent };